import { render, staticRenderFns } from "./NewFood.vue?vue&type=template&id=52e5e93b&scoped=true&"
import script from "./NewFood.vue?vue&type=script&lang=js&"
export * from "./NewFood.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e5e93b",
  null
  
)

export default component.exports